/*
 * <suppliers-carousel> runs a single Flickity carousel of Cover/Intro/Chart
 * slides inside one "Our Suppliers" grid tile. Unlike <reviews-carousel>
 * (several cards peeking side by side), each slide here fills the whole
 * tile, and the carousel does not wrap around: at the first/last slide the
 * corresponding arrow is disabled (dimmed via CSS in section-suppliers-grid.css,
 * not hidden), matching the "Our Suppliers" design reference.
 */
if (!customElements.get('suppliers-carousel')) {
  class SuppliersCarousel extends HTMLElement {
    constructor() {
      super();
      this.resizeOnCssLoad = () => this.resizeSlider();
      this.flkty = null;
    }

    connectedCallback() {
      this.initSlider();
      // Same fix as <reviews-carousel>: the section's CSS loads async (see
      // the rel="preload" swap in section-suppliers-grid.liquid), so
      // Flickity's very first layout pass can run before real dimensions are
      // in place. That preload's onload dispatches this event, and resizing
      // here corrects the layout without requiring an actual window resize.
      document.addEventListener('theme:resize:width', this.resizeOnCssLoad);
    }

    initSlider() {
      if (this.flkty !== null) {
        return;
      }
      if (this.querySelectorAll('[data-slide]').length > 1) {
        this.flkty = new window.theme.Flickity(this, {
          prevNextButtons: true,
          pageDots: false,
          wrapAround: false,
          adaptiveHeight: false,
          // Every slide here is a full-bleed, absolutely-positioned image
          // (via image-fill's is_background mode) with no natural in-flow
          // height, so Flickity's default cell-measuring (setGallerySize:
          // true) reports 0 and writes height: 0px onto .flickity-viewport.
          // The real height instead comes from this element's own CSS
          // (height: 100% of its fixed-aspect-ratio grid tile - see
          // section-suppliers-grid.css), so tell Flickity not to override it.
          setGallerySize: false,
        });
      }
    }

    resizeSlider() {
      if (this.flkty !== null) {
        this.flkty.resize();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('theme:resize:width', this.resizeOnCssLoad);
      if (this.flkty !== null) {
        this.flkty.destroy();
        this.flkty = null;
      }
    }
  }
  customElements.define('suppliers-carousel', SuppliersCarousel);
}
